import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { formControlElement, formLabelElement } from 'src/app/animations/animations';
import { MaxWordLimit } from 'src/app/constants/constants';
import { DataService } from 'src/app/core/services/data_service';
import { DataServiceProposalOverview } from 'src/app/core/services/data_service_proposal_overview';
import { SessionStorageService } from 'src/app/core/services/session_storage';

@Component({
    selector: 'app-formation-proposal-overview',
    templateUrl: './formation-proposal-overview.component.html',
    styleUrls: ['./formation-proposal-overview.component.less'],
    animations: [formControlElement, formLabelElement],
    standalone: false
})
export class FormationProposalOverviewComponent {
  @Input() formationProposalOverviewForm!: UntypedFormGroup;
  wordLimit = MaxWordLimit;
  constructor(
    private session: SessionStorageService,
    private dataservice: DataService,
    private proposalOverviewDataService: DataServiceProposalOverview
  ) {}

}
